import React, { useState, useEffect } from 'react';
import firebase from 'firebase';
import { connect, useDispatch } from 'react-redux';
import styled from 'styled-components';
import {
  Typography,
  TextField,
} from '@material-ui/core';
import { setBoard } from '../../store/board/actions';
import AddPedal from '../AddPedal';
import synai from './synai.png';

const Item = styled.div`
  margin-bottom: 32px;
`;

const AsideContent = ({ board }) => {
  const dispatch = useDispatch();
  const [boards, setBoards] = useState([]);
  const [boardsLoading, setBoardsLoading] = useState(false);

  const selectBoard = (id) => {
    dispatch(setBoard(boards.find(item => item.id === id)));
  }

  useEffect(() => {
    const exec = async () => {
      setBoardsLoading(true);
      const data = await firebase.firestore().collection('boards').get();
      setBoards(data.docs.map(item => ({ ...item.data(), id: item.id })));
      setBoardsLoading(false);
    }
    exec();
  }, []);

  useEffect(() => {
    if (boards[0]) {
      selectBoard(boards[0].id);
    }
  }, [boards]);

  return <>
    {
      boardsLoading ? (
        <Item>
          <Typography variant="subtitle1">
            Carregando BOARDS...
          </Typography>
        </Item>
      ) : boards && <>
        <Item>
          <TextField
            color="secondary"
            select
            SelectProps={{
              native: true,
            }}
            label="Escolha seu board"
            onChange={e => selectBoard(e.target.value)}
            fullWidth
            value={board && board.id}
            className="textfield-board"
          >
            { boards.map((item) => (
              <option key={item.id} value={item.id}>{item.name}</option>
            )) }
          </TextField>
        </Item>
        <Item>
          <AddPedal />
        </Item>
      </>
    }
    <h2 className="credits">
      <a href="https://synai.co" target="blank">
        <img src={synai} alt="" />
      </a>
    </h2>
  </>;
}

export default connect(state => ({ board: state.board }))(AsideContent);
